import { render, staticRenderFns } from "./GarageEntrances.vue?vue&type=template&id=56adec81&scoped=true&"
import script from "./GarageEntrances.vue?vue&type=script&lang=js&"
export * from "./GarageEntrances.vue?vue&type=script&lang=js&"
import style0 from "./GarageEntrances.vue?vue&type=style&index=0&id=56adec81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56adec81",
  null
  
)

export default component.exports